// DEPENDENCIES ---------------------------------------------------------------- //

// import React from 'react';

import { Moves } from '@gql/base-types';
import { isMoveLite } from '@utils/tiers';

import { formatMoveId } from '@services/moveService';
import { copyToClipboard } from '@services/utilityService';

import { Chip, Tooltip } from '@mui/material';
import { BiFingerprint } from 'react-icons/bi';

// TYPES ---------------------------------------------------------------------- //

interface MoveIdBadgeProps {
  move?: Moves;
}

// COMPONENT ------------------------------------------------------------------ //

const MoveIdBadge = ({ move }: MoveIdBadgeProps) => {
  if (!move) return null;

  const moveId = formatMoveId(move?.id ?? 0, { includeHash: false, isLite: isMoveLite(move) });

  const handleCopy = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    copyToClipboard(moveId);
  };

  return (
    <Tooltip title='Click to copy Move ID' placement='top'>
      <Chip
        color='utility'
        label={moveId}
        icon={<BiFingerprint size={14} />}
        onClick={handleCopy}
        sx={{ fontWeight: 'bold', cursor: 'pointer' }}
      />
    </Tooltip>
  );
};

export default MoveIdBadge;
